module.exports = __webpack_public_path__ + "static/media/3.17e3211e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/slides/3.jpg
// module id = 780
// module chunks = 0